import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { trainingMatrixApi } from '@/entities/Training';
import type { TrainingMatrixPositionRow } from '@/entities/Training';
import { useCustomToast } from '@/shared/lib';

export function useTrainingMatrixGeneratedReport() {
  const route = useRoute();
  const router = useRouter();
  const toast = useCustomToast();

  const loading = ref(true);
  const positions = ref<TrainingMatrixPositionRow[]>([]);
  const revisionNumber = ref<number | null>(null);

  function redirectToMatrixTab(): void {
    router.push({ name: 'TreinamentosMatrizTreinamentos' });
  }

  async function fetchReport(): Promise<void> {
    const revisionId = Number(route.query.revisionId);
    if (!Number.isInteger(revisionId) || revisionId <= 0) {
      toast.showErrorToast({
        title: 'Revisão inválida',
        message: 'Selecione uma revisão para gerar a matriz.',
        type: 'error',
      });
      redirectToMatrixTab();
      return;
    }

    loading.value = true;
    try {
      const result = await trainingMatrixApi.getRevisionDetail(revisionId, { allItems: true });
      positions.value = result.data.positions;
      revisionNumber.value = result.data.revision.revision;
    } catch {
      toast.showErrorToast({
        title: 'Erro ao gerar matriz',
        message: 'Não foi possível carregar os dados da revisão selecionada. Tente novamente.',
        type: 'error',
      });
      redirectToMatrixTab();
    } finally {
      loading.value = false;
    }
  }

  void fetchReport();

  return {
    loading,
    positions,
    revisionNumber,
  };
}
